import React from 'react';
import { Box, Paper, Typography, Fade } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import PersonIcon from '@mui/icons-material/Person';
import { useGame } from '../contexts/GameContext';

export default function ActiveRules() {
  const { state } = useGame();
  const { global, personal } = state.activeRules;

  if (!global && personal.length === 0) return null;

  return (
    <Fade in timeout={500}>
      <Paper 
        sx={{ 
          p: 2,
          mt: 3,
          bgcolor: 'background.default',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '1rem',
        }}
      >
        <Typography 
          variant="h6" 
          sx={{ 
            mb: 2,
            fontWeight: 'bold',
            background: 'linear-gradient(45deg, #90caf9 30%, #f48fb1 90%)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          <GavelIcon fontSize="small" />
          Aktive Regeln
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {global && (
            <Box>
              <Typography 
                variant="subtitle2" 
                color="primary.light"
                sx={{ mb: 0.5, fontSize: '0.8rem' }}
              >
                Globale Regel:
              </Typography>
              <Typography variant="body2">
                {global}
              </Typography>
            </Box>
          )}

          {personal.length > 0 && (
            <Box>
              <Typography 
                variant="subtitle2" 
                color="secondary.light"
                sx={{ 
                  mb: 0.5, 
                  fontSize: '0.8rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <PersonIcon fontSize="small" />
                Persönliche Regeln:
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {personal.map((rule, index) => (
                  <Typography 
                    key={index} 
                    variant="body2"
                    sx={{
                      pl: 1,
                      borderLeft: '2px solid',
                      borderColor: 'secondary.main'
                    }}
                  >
                    {rule}
                  </Typography>
                ))}
              </Box>
            </Box>
          )}
        </Box>
      </Paper>
    </Fade>
  );
} 